module.exports = "### Overriding with CSS Styles\n\nThe **second way** to override the style of the components is to use the *css-style* approach.\n\nEvery component provides a `className` property. Those properties are always applied to the *root* element.\n\nNote that CSS properties defined inline are given priority over those defined\nin a CSS class. You need to use `!important` to take precedence over the inline style.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/customization/styles-overriding-css.md
 ** module id = 1098
 ** module chunks = 0
 **/